import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { HTTP_STATUSES } from "../../../utils/consts";

const ServicesSelect = ({
  checkedService,
  setCheckedService,
  isObject = true,
  defaultOption = false,
  rateService = false
}) => {
  const { t } = useTranslation("otherInterface");
  const [userServices, setUserServices] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [fetchingServices, setFetchingServices] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const filterData = rateService ? "?rateService=true" : "";

  useEffect(() => {
    axios.get(`/api/user-services${filterData}`, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setUserServices(response.data["hydra:member"]);
        setFetchingServices(false);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, []);

  if (forbidden) {
    return "Forbidden";
  }

  if (fetchingServices) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(userServices).length === 0) {
    return "Empty Services";
  }

  return (
    <>
      <FormControl>
        <Autocomplete
          options={(isObject ? userServices.map(service => service.service) : userServices.map(service => service.service.name)) || []}
          value={checkedService || null}
          onChange={(event, checkedService) => setCheckedService(checkedService)}
          getOptionLabel={(option) => isObject ? option.name : option}
          renderInput={(params) => (
            <TextField {...params} label={rateService ? t("services.rateBaseService") : t("services.service")} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default ServicesSelect;